import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Authentication failed: No session ID');
          navigate('/auth', { replace: true });
          return;
        }

        // Exchange session_id for user data
        const response = await fetch(`${BACKEND_URL}/api/auth/google/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.detail || 'Authentication failed');
        }

        // Store token and user data (compatible with existing auth flow)
        localStorage.setItem('medbuddy_token', data.access_token);
        localStorage.setItem('medbuddy_user', JSON.stringify(data.user));

        // Update auth state
        setIsAuthenticated(true);
        
        toast.success(`Welcome, ${data.user.name}!`);
        
        // Clear the URL fragment and navigate to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/today', { replace: true, state: { user: data.user } });
        
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error(error.message || 'Authentication failed');
        navigate('/auth', { replace: true });
      }
    };

    processAuth();
  }, [navigate, setIsAuthenticated]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center p-4" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4 border-4 border-green-600 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-xl text-gray-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
